let uid = 0;

export const SolanaLogo = ({ size = 32, className = "", style }) => {
  const id = `solg-${++uid}`;
  return (
    <svg
      width={size}
      height={size * 0.78}
      viewBox="0 0 100 78"
      fill="none"
      className={className}
      style={style}
      aria-hidden="true"
    >
      <defs>
        <linearGradient id={id} x1="0" y1="78" x2="100" y2="0" gradientUnits="userSpaceOnUse">
          <stop stopColor="#9945FF" />
          <stop offset="0.5" stopColor="#5497D5" />
          <stop offset="1" stopColor="#14F195" />
        </linearGradient>
      </defs>
      <path d="M16.6 59.6a3.9 3.9 0 0 1 2.8-1.2h77.4c1.7 0 2.6 2.1 1.4 3.3L82.9 77a3.9 3.9 0 0 1-2.8 1.2H2.7c-1.7 0-2.6-2.1-1.4-3.3l15.3-15.3Z" fill={`url(#${id})`} />
      <path d="M16.6 1.2A4 4 0 0 1 19.4 0h77.4c1.7 0 2.6 2.1 1.4 3.3L82.9 18.6a3.9 3.9 0 0 1-2.8 1.2H2.7c-1.7 0-2.6-2.1-1.4-3.3L16.6 1.2Z" fill={`url(#${id})`} />
      <path d="M82.9 30.2a3.9 3.9 0 0 0-2.8-1.2H2.7c-1.7 0-2.6 2.1-1.4 3.3l15.3 15.3a3.9 3.9 0 0 0 2.8 1.2h77.4c1.7 0 2.6-2.1 1.4-3.3L82.9 30.2Z" fill={`url(#${id})`} />
    </svg>
  );
};
